import { GlintsChatChannel } from '../types/channel';
import { GlintsChatMessage } from '../types/message';

export const WSEventOperation = {
  READ_MESSAGE: 'READ_MESSAGE',
  NEW_MESSAGE: 'NEW_MESSAGE',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  UPDATE_CHANNEL: 'UPDATE_CHANNEL',

  // Local Event From HAPI
  CONNECTION_ESTABLISHED: 'CONNECTION_ESTABLISHED',

  // Local Event from Client
  CONNECTION_CHANGE: 'CONNECTION_CHANGE',
  RECONNECTED: 'RECONNECTED',
  CONNECTION_LIMIT_REACHED: 'CONNECTION_LIMIT_REACHED',
} as const;

export type WSEventOperation =
  (typeof WSEventOperation)[keyof typeof WSEventOperation];

export type ConnectionEstablishedEvent = {
  operation: typeof WSEventOperation.CONNECTION_ESTABLISHED;
};

export type MessageReadEvent = {
  operation: typeof WSEventOperation.READ_MESSAGE;
  opData: {
    messageID: string;
    channelID: string;
    userID: string;
  };
};

export type MessageCreateEvent = {
  operation: typeof WSEventOperation.NEW_MESSAGE;
  opData: {
    channelID: string;
    message: GlintsChatMessage;
    channelInfo: Omit<GlintsChatChannel, 'messageList'>;
  };
};

export type MessageUpdateEvent = {
  operation: typeof WSEventOperation.UPDATE_MESSAGE;
  opData: {
    channelID: string;
    message: GlintsChatMessage;
    channelInfo: Omit<GlintsChatChannel, 'messageList'>;
  };
};

export type ChannelUpdateEvent = {
  operation: typeof WSEventOperation.UPDATE_CHANNEL;
  opData: Omit<GlintsChatChannel, 'messageList'>;
};

export type ConnectionChangeEvent = {
  operation: typeof WSEventOperation.CONNECTION_CHANGE;
  opData: {
    connected: boolean;
  };
};

export type ReconnectedEvent = {
  operation: typeof WSEventOperation.RECONNECTED;
};

export type ConnectionLimitReached = {
  operation: typeof WSEventOperation.CONNECTION_LIMIT_REACHED;
  opData: {
    reached: boolean;
  };
};

export type GlintsChatWSEvent =
  | ConnectionEstablishedEvent
  | MessageReadEvent
  | MessageCreateEvent
  | MessageUpdateEvent
  | ChannelUpdateEvent
  | ConnectionChangeEvent
  | ReconnectedEvent
  | ConnectionLimitReached;

export const isGlintsChatWSEvent = (event: any): event is GlintsChatWSEvent =>
  event && typeof event === 'object' && 'operation' in event;

export type WSEventHandler = (event: GlintsChatWSEvent) => void;
